module.exports = __webpack_public_path__ + "static/Adieu-Light-7353b657c0c228957beb8266f137a3a9.otf";